import type { ReactElement, ReactNode } from 'react';
import type { Breadcrumb } from '@ps-refarch-ux/neon';
import { NeonBreadcrumbs } from '@ps-refarch-ux/neon';
import { PageTitle } from '@/components/PageTitle/page-title';
import styles from './form-page-shell.module.scss';

export interface FormPageShellProps {
  dataTestId: string;
  breadcrumbs: Breadcrumb[];
  breadcrumbsId: string;
  pageTitle: ReactNode;
  /** When `plain`, `pageTitle` is rendered without the default `<PageTitle>` wrapper (e.g. custom heading row). */
  pageTitleVariant?: 'default' | 'plain';
  children: ReactNode;
}

/** Page chrome: breadcrumbs, title, main stack (footer actions live in staff layout). */
export function FormPageShell({
  dataTestId,
  breadcrumbs,
  breadcrumbsId,
  pageTitle,
  pageTitleVariant = 'default',
  children,
}: FormPageShellProps): ReactElement {
  return (
    <div data-testid={dataTestId} className={styles.page}>
      <NeonBreadcrumbs breadcrumbs={breadcrumbs} id={breadcrumbsId} />
      {pageTitleVariant === 'plain' ? pageTitle : <PageTitle>{pageTitle}</PageTitle>}
      <div className={styles.formPageStack}>{children}</div>
    </div>
  );
}
